import { useEffect } from 'react';
import { observer } from 'mobx-react';
import AppTable from '../../../../components/AppTable';
import { ADMIN_PAGE } from '../../../../constants';
import UsersDetails from '../UserDetails';
import { useStores } from 'stores';
import Spinner from '../../../../components/Spinner';

export const settings = {
  title: 'Users',
  columns: [
    { title: 'User id', dataColumn: 'id', isVisible: false, isSearchable: false },
    { title: 'Login', dataColumn: 'userName', isVisible: true, isSearchable: true },
    { title: 'User domain name', dataColumn: 'userDomainName', isVisible: false, isSearchable: false },
    { title: 'Email', dataColumn: 'email', isVisible: false, isSearchable: false },
    { title: 'First name', dataColumn: 'firstName', isVisible: true, isSearchable: true },
    { title: 'Last name', dataColumn: 'lastName', isVisible: true, isSearchable: true },
    { title: 'Phone', dataColumn: 'phoneNumber', isVisible: true, isSearchable: true },
    { title: 'Location ID', dataColumn: 'locationId', isVisible: false, isSearchable: false },
    { title: 'Location name', dataColumn: 'location', isVisible: false, isSearchable: false },
    { title: 'Favorite lots', dataColumn: 'favoriteLotsCount', isVisible: false, isSearchable: false },
    { title: 'Account created', dataColumn: 'createDate', isVisible: false, isSearchable: false },
    { title: 'Account updated', dataColumn: 'updateDate', isVisible: false, isSearchable: false },
    { title: 'Last login date', dataColumn: 'lastLoginDate', isVisible: false, isSearchable: false },
  ],
  rowKey: 'id',
  Details: UsersDetails,
};

const AdminUsersList = () => {
  const { adminStore } = useStores();
  const { users, isLoading, fetchUsers } = adminStore;

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  if (isLoading) {
    return <Spinner spinning />;
  }

  return <AppTable settings={settings} rows={users} title={ADMIN_PAGE.title} searchPlaceholder="Search users" />;
};

export default observer(AdminUsersList);
